import gql from 'graphql-tag';

export { getCommDevice } from './getCommDevice';

const COMM_DEVICE_DETAIL_FRAGMENT = gql`
	fragment commDeviceDetail on CommDevice {
		id
		deviceId
		secondaryId
		archived
		destroyed
		lastCommunication
		lastHeartbeat
		rootTenantId
		rootTenant {
			id
			name
		}
		pointOfSale {
			id
			assetId
			location {
				id
				name
			}
			place {
				id
				name
			}
		}
		shouldReboot
		showCameraPreview
		manufacturer
		receivedCommunicationTypes
		salesDataSource
		commDeviceLayout {
			id
			items {
				id
				price
				row
				column
				selection
				salesSinceInit
				vendsSinceInit
				productText
			}
			commDeviceIngredientLayout {
				id
				items {
					id
					row
					column
					selection
					salesSinceInit
					vendsSinceInit
				}
			}
		}
		setupInformation
		latestHeartbeatData
		notes {
			id
			description
			isAdminNote
			isImportant
			created
			creator {
				id
				firstname
				lastname
				destroyed
			}
		}
	}
`;

export const GET_COMM_DEVICE = gql`
	query($id: String, $includeDestroyed: Boolean) {
		getCommDevice(id: $id, includeDestroyed: $includeDestroyed) {
			...commDeviceDetail
		}
	}
	${COMM_DEVICE_DETAIL_FRAGMENT}
`;

export const MODIFY_COMM_DEVICE = gql`
	mutation modifyCommDeviceMutation($input: ModifyCommDeviceInput!) {
		modifyCommDevice(input: $input) {
			commdevice {
				...commDeviceDetail
			}
		}
	}
	${COMM_DEVICE_DETAIL_FRAGMENT}
`;

export const SUBSCRIBE_TO_COMM_DEVICE = gql`
	subscription ($input: CommDeviceSubscriptionInput!) {
		CommDeviceSubscription(input: $input) {
			commdevice {
				...commDeviceDetail
			}
			destroyedCommDeviceId
		}
	}
	${COMM_DEVICE_DETAIL_FRAGMENT}
`;

export const ARCHIVE_COMM_DEVICE = gql`
  mutation archiveCommDeviceMutation ($id: ID!) {
    archiveCommDevice(id: $id)
  }
`;

export const DESTROY_COMM_DEVICE = gql`
  mutation destroyCommDeviceMutation ($id: ID!) {
    destroyCommDevice(id: $id)
  }
`;

export const CREATE_COMM_DEVICE = gql`
	mutation createCommDeviceMutation($input: CreateCommDeviceInput!) {
		createCommDevice(input: $input) {
			id
		}
	}
`;

export const GET_COMM_DEVICE_NOTES = gql`
	query($id: String) {
		getCommDevice(id: $id) {
			id
			notes {
				id
				description
				created
				isAdminNote
				isImportant
				creator {
					id
					firstname
					lastname
					destroyed
				}
			}
		}
	}
`;
